import {ValidationErrors} from '@angular/forms';
import {capitalizeFirst, splitToWord} from '../../shared-utils/primitives/human-readablility.utils';


export const _VALID_AUTO_ORDERING_TOKEN_KEYS: Readonly<{ [key: string]: string }> = {
  ['{Account #}']: 'Supplier Code',
  ['{Order #}']: 'Purchase Order Number',
  ['{Store Name}']: 'Store Name',
  ['{Contact Name}']: 'Rep Name',
  ['{Contact Number}']: 'Contact Number',
};

//#region REGEX
export const PHONE_PATTERN_REGEX = /^\+?\d{1,4}?[\s-]?\(?\d{1,4}\)?[\s-]?\d{3,4}[\s-]?\d{3,4}$/;

export const VAR_ALL_REGEX =
  /^(?:[^{}]*\{(?:Order #|Account #|Contact Name|Contact Number|Store Name)\}[^{}]*)*[^{}]*$/;

//#endregion

export function getFieldErrorString(errors: ValidationErrors, field: string): string {
  let errorString = '';

  if (!errors) return '';
  switch (field) {
    case 'body':
      if (errors['required']) errorString += 'Body is a required field.\n';
      if (errors['pattern']) {
        errorString += `The body contains an invalid token.\n`;
        errorString += `\tValid Tokens: {Account #}, {Contact Name}, {Contact Number}, {Order #}, {Store Name}\n`;
      }
      break;
    case 'cellphone':
    case 'contactName':
      if (errors['required']) errorString += 'Cellphone Number is a required field.\n';
      if (errors['pattern']) errorString += 'Please enter a valid cellphone number.\n';
      break;
    case 'ccRecipients':
      if (errors['email']) errorString += 'Please enter a valid email address for CC Recipients.\n';
      break;
    case 'email':
      if (errors['required']) errorString += 'Email address is a required field.\n';
      if (errors['email']) errorString += 'Please enter a valid email address.\n';
      break;
    case 'subject':
      if (errors['required']) errorString += 'Subject is a required field.\n';
      if (errors['pattern']) {
        errorString += `The subject contains an invalid token.\n`;
        errorString += `\tValid Tokens: {Account #}, {Contact Name}, {Contact Number}, {Order #}, {Store Name}\n`;
      }
      break;
    case 'username':
      if (errors['required']) errorString += 'Username is required.\n';
      if (errors['minlength'])
        errorString += `Username must be at least ${errors['minlength'].requiredLength} characters long.\n`;
      if (errors['maxlength'])
        errorString += `Username cannot exceed ${errors['maxlength'].requiredLength} characters.\n`;
      if (errors['pattern'])
        errorString += 'Username contains invalid characters.\n';
      break;
    case 'digits':
      if (errors['required']) errorString += 'Number of digits is required.\n';
      if (errors['min']) errorString += `Number of digits must be at least ${errors['min'].min}.\n`;
      if (errors['max']) errorString += `Number of digits cannot exceed ${errors['max'].max}.\n`;
      break;
    case 'prefix':
      if (errors['required']) errorString += 'Prefix is required.\n';
      if (errors['maxlength']) errorString += `Prefix cannot exceed ${errors['maxlength'].requiredLength} characters.\n`;
      break;
    case 'suffix':
      if (errors['required']) errorString += 'Suffix is required.\n';
      if (errors['maxlength']) errorString += `Suffix cannot exceed ${errors['maxlength'].requiredLength} characters.\n`;
      break;
    case 'customPrefix':
      if (errors['maxlength']) errorString += `Custom prefix cannot exceed ${errors['maxlength'].requiredLength} characters.\n`;
      break;
    case 'customSuffix':
      if (errors['maxlength']) errorString += `Custom suffix cannot exceed ${errors['maxlength'].requiredLength} characters.\n`;
      break;
    case 'descPrefix':
      if (errors['maxlength']) errorString += `Description prefix cannot exceed ${errors['maxlength'].requiredLength} characters.\n`;
      break;
    case 'descSuffix':
      if (errors['maxlength']) errorString += `Description suffix cannot exceed ${errors['maxlength'].requiredLength} characters.\n`;
      break;
    case 'lineColour':
      if (errors['min']) errorString += `Line colour code must be at least ${errors['min'].min}.\n`;
      if (errors['max']) errorString += `Line colour code cannot exceed ${errors['max'].max}.\n`;
      break;
    case 'onHoldCode':
      if (errors['min']) errorString += `On-hold code must be at least ${errors['min'].min}.\n`;
      break;
    case 'pct':
      if (errors['min']) errorString += `Maximum increase in price must be at least ${errors['min'].min}%.\n`;
      if (errors['max']) errorString += `Maximum increase in price cannot exceed ${errors['max'].max}%.\n`;
      break;
    case 'negPct':
      if (errors['min']) errorString += `Maximum decrease in price must be at least ${errors['min'].min}%.\n`;
      if (errors['max']) errorString += `Maximum decrease in price cannot exceed ${errors['max'].max}%.\n`;
      break;
    case 'growth':
      if (errors['required']) errorString += 'Growth estimation is a required field.\n';
      if (errors['min']) errorString += `Growth estimation must be at least ${errors['min'].min}%.\n`;
      if (errors['max']) errorString += `Growth estimation cannot exceed ${errors['max'].max}%.\n`;
      break;
    case 'monthsHistory':
      if (errors['required']) errorString += 'Months of history is a required field.\n';
      if (errors['min']) errorString += `Months of history must be at least ${errors['min'].min}.\n`;
      if (errors['max']) errorString += `Months of history cannot exceed ${errors['max'].max}.\n`;
      break;
    case 'period':
      if (errors['required']) errorString += 'Ordering method is a required field.\n';
      if (errors['min']) errorString += `Ordering method must be at least ${errors['min'].min}.\n`;
      if (errors['max']) errorString += `Ordering method cannot exceed ${errors['max'].max}.\n`;
      break;
    case 'stockDays':
      if (errors['required']) errorString += 'Stock days is a required field.\n';
      if (errors['min']) errorString += `Stock days must be at least ${errors['min'].min}.\n`;
      if (errors['max']) errorString += `Stock days cannot exceed ${errors['max'].max}.\n`;
      break;
    default:
      if (errors['required'])
        errorString += `${splitToWord(field)} is a required field.\n`;
      if (errors['email'])
        errorString += `The value provided for ${capitalizeFirst(field)} is not a valid email.\n`;
      if (errors['pattern'])
        errorString += `The value provided for ${capitalizeFirst(field)} is invalid.\n`;
      if (errors['minlength'])
        errorString += `${capitalizeFirst(field)} must be at least ${errors['minlength'].requiredLength} characters long.\n`;
      if (errors['maxlength'])
        errorString += `${capitalizeFirst(field)} cannot exceed ${errors['maxlength'].requiredLength} characters.\n`;
      break;
  }

  return errorString.trimEnd();
}
